import React from 'react';
import videoBg from '../img/4 July.mp4';
import video from '../img/videos.mp4';
import './Home.css';
import { motion, AnimatePresence } from 'framer-motion';

import sliderImg1 from '../img/111 (1).jpeg';
import sliderImg2 from '../img/111 (2).jpeg';
import sliderImg3 from '../img/111 (3).jpeg';
import sliderImg4 from '../img/111 (4).jpeg';
import sliderImg5 from '../img/111 (5).jpeg';
import sliderImg6 from '../img/111 (6).jpeg';
import sliderImg7 from '../img/111 (7).jpeg';
import serviceImage from '../img/pic2.jpg'; // Your service image
import collageImage from '../img/pic3.jpg';
import lahore from '../img/lahore.jpg';
import sialkot from '../img/sialkot.jpg';
import karachi from '../img/karachi.JPG'; // Your small business image
import { Link } from 'react-router-dom';
import vision from '../img/vision.PNG';
import isb from '../img/isb.jpg';
import { FaPhoneAlt } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaHeadset } from "react-icons/fa";
import fsd from '../img/fsd.jpg';
import pess from '../img/pess.jpg';
import wa from '../img/wa.png';


import { useState, useEffect, useRef } from 'react';

function Home() {
  const sliderImages = [
    sliderImg1,
    sliderImg2,
    sliderImg3,
    sliderImg4,
    sliderImg5,
    sliderImg6,
    sliderImg7
  ];
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timeoutRef = useRef(null);

  const goToSlide = (idx) => setCurrent(idx);

  // Auto-running (autoplay) effect with pause on hover
  useEffect(() => {
    if (isPaused) return;
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % sliderImages.length);
    }, 4000);
    return () => clearTimeout(timeoutRef.current);
  }, [current, isPaused, sliderImages.length]);

  return (
    <div className="home-container">
      {/* Background Video Section */}
      <div className="content-wrapper">

        {/* Hero Section */}
        <motion.div
          className="announcement-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <div className="video-background-wrapper">
            <video
              className="background-video"
              src={video}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
          <div className="announcement-content">
            <p className="about-us-text">
              <strong>UPS Pakistan ASC – Customer Update</strong>
            </p>
            <p>
              We are pleased to announce the launch of our dedicated charter flight from Pakistan to Cologne, ensuring reliable cargo capacity to Europe despite ongoing regional disruptions. ✈️
            </p>
            <p>Daily charters are now back, reaffirming that our commitment to Pakistan and its exporters remains stronger than ever.</p>
            <p>Pakistan to Cologne - stability in a time of disruption.</p>
            <p>For bookings and details, please contact our UAN: 021-111-669-877</p>
            <p>Your Priority. Our Promise. Globally Delivered.</p>
          </div>
        </motion.div>
        <motion.div
          className="hero-section"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}
        >
          {/* Two-column layout: left (video bg + text), right (image) */}
          <div style={{ display: 'flex', width: '100%', gap: '50px', justifyContent: 'center', alignItems: 'center' }}>
            {/* Left: Image with animation */}
            <div className="video-container">
              <video
                src={videoBg}
                className="hero-image"
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  backgroundColor: '#351c15',
                  borderRadius: '8px',
                }}
              />
            </div>
            {/* Right: Image slider only */}
            <div
              className="slider-container"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div className="slider-wrapper" style={{ position: 'relative', width: '100%', height: '100%' }}>
                <AnimatePresence mode="wait">
                  <motion.img
                    key={current}
                    src={sliderImages[current]}
                    alt={`Slide ${current + 1}`}
                    className="hero-image"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1.2, ease: "easeInOut" }}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      backgroundColor: '#351c15',
                      borderRadius: '8px',
                    }}
                  />
                </AnimatePresence>
              </div>
              {/* Dots navigation */}
              <div className="slider-dots">
                {sliderImages.map((_, idx) => (
                  <span
                    key={idx}
                    className={`slider-dot${idx === current ? ' active' : ''}`}
                    onClick={() => goToSlide(idx)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </motion.div>



        <motion.div
          className="text-content"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{
            maxWidth: '45%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            textAlign: 'center'
          }}
        >
          <h2 style={{ color: '#351c15', textAlign: 'center' }}>Let ULS Help Grow Your Business</h2>
          <div className="underline" style={{ margin: '0 auto' }}></div>
          <p style={{ color: 'black', textAlign: 'center' }}>
            Looking for fast, reliable shipping or industry-leading logistics solutions? ULS provides the expertise to streamline your operations.
          </p>
          <Link to="/Shipments" style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center' }}>
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="cta-button"
              style={{ backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', padding: '10px 20px', cursor: 'pointer' }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>


        {/* Announcement Section with video background and overlay text */}



        {/* End of Background Video Section - Company Header starts here */}


        {/* World-Class Services Section */}
        <motion.div
          className="services-section"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}
        >
          {/* Left Service Card */}
          <motion.div
            className="service-card"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ flex: 1, background: '#f7f7f7', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
          >
            <img src={serviceImage} alt="Customer First" style={{ width: '100%', borderRadius: '8px' }} />
            <h3 style={{ color: '#351c15' }}>Customer First</h3>
            <p style={{ color: 'black', textAlign: 'left' }}>We prioritize our customers and their needs, ensuring an exceptional experience every time.</p>
          </motion.div>

          {/* Right Service Card */}
          <motion.div
            className="service-card"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.7 }}
            style={{ flex: 1, background: '#f7f7f7', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
          >
            <img src={collageImage} alt="Innovative Solutions" style={{ width: '100%', borderRadius: '8px' }} />
            <h3 style={{ color: '#351c15' }}>Innovative Solutions</h3>
            <p style={{ color: 'black', textAlign: 'left' }}>Our forward-thinking approach helps us stay ahead of the curve, offering innovative logistics services.</p>
          </motion.div>
        </motion.div>
        <div>  <h3 style={{ color: '#351c15' }}>Our Service Centers </h3></div>

        {/* Small Business Growth Section */}
        {/* Office Locations Section */}
        {/* Office Locations Section */}
        <motion.div
          className="office-locations"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          {/* Office 1 */}
          <motion.div
            className="office-card"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <img src={karachi} alt="Karachi Office" />
            <h3>Karachi</h3>
            <p>E15 Block 6 PECHS Nursery, Shahrah-e-Faisal<br></br> Karachi, Pakistan</p>
            <p><FaPhoneAlt /> (0092) 21-34521187  <FaHeadset /> (0092) 21-111669877</p>


            <a href="https://www.google.com/maps?q=24.8596337,67.0657547" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>

          {/* Office 2 */}
          <motion.div
            className="office-card"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.7 }}
          >
            <img src={lahore} alt="Lahore Office" />
            <h3>Lahore</h3>
            <p>204- Scotch Corner, Uper Mall<br></br> Lahore, Pakistan</p>
            <p><FaPhoneAlt /> (0092) 42-35753888, 35754666</p>

            <a href="https://www.google.com/maps?q=31.543372414055295,74.35411971970743" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>

          {/* Office 3 */}
          <motion.div
            className="office-card"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <img src={sialkot} alt="Sialkot Office" />
            <h3>Sialkot</h3>
            <p>Chowk Anwar Khawaja Monument, Haji Pura Road Near, Faysal Bank, Sialkot, Pakistan </p>
            <p><FaPhoneAlt /> (0092) 52-3556447, 3556344</p>
            <a href="https://www.google.com/maps?q=32.473460674551234,74.51881949317858" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>

          <motion.div
            className="office-card"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <img src={isb} alt="Islamabad Office" />
            <h3>Islamabad</h3>
            <p>Plot#3, Faqeer Aipee Road, i-11/2, <br></br>Islamabad, Pakistan</p>
            <p><FaPhoneAlt /> (0092) 51-8733361-62, 4863971-72</p>
            <a href="https://www.google.com/maps?q=33.643544744771546,73.02197573414695" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>
          <motion.div
            className="office-card"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <img src={pess} alt="Peshawar Office" />
            <h3>Peshawar</h3>
            <p>MDF 23, Namal Palaza Khyber Super Market, Bara Road, Near Qayyum Stadium</p>
            <p><FaPhoneAlt /> (0092) 91-5252046-47</p>
            <a href="https://www.google.com/maps?q=33.98999008689488,71.53431641136997" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>



          <motion.div
            className="office-card"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <img src={fsd} alt="Faisalabad Office" />
            <h3>Faisalabad</h3>
            <p>Office No. 13 Regency Int. 949, The Mall, Near Best Western Hotel, OPP PIA Office</p>
            <p><FaPhoneAlt /> (0092) 41-2600236</p>

            <a href="https://www.google.com/maps?q=31.42243233736654,73.08960740199518" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="cta-button"
                style={{ padding: '10px 20px', backgroundColor: '#ffc400', color: 'black', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                <FaMapMarkerAlt />Location
              </motion.button>
            </a>
          </motion.div>




























        </motion.div>
        <h1 style={{ color: '#351c15' }}>OUR VISION</h1>
        <motion.img
          src={vision}
          alt="Our Vision"
          className="hero-images"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{ width: '100%', borderRadius: '8px' }}
        />
        <motion.div
          className="whatsapp-widget"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: '#25d366',
            borderRadius: '50%',
            padding: '15px',
            cursor: 'pointer',
          }}
        >
          <a href="https://wa.me/92021111669877" target="_blank" rel="noopener noreferrer">
            <img src={wa} alt="WhatsApp" style={{ width: '40px', height: '40px' }} />
          </a>
        </motion.div>

      </div>

    </div>

  );
}

export default Home;
